import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useState } from 'react';
import { Button, Card, Grid, Header, Tab } from 'semantic-ui-react';
import PhotoUploadWidget from '../../app/common/imageUpload/PhotoUploadWidget';
import { Photo } from '../../app/models/Profile';
import { useStore } from '../../app/stores/store';
import { useEffect } from 'react';
import '../../app/common/MediaQuery/responsive-user-profile.css';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import ImageTag from './RenderImage';
import UnauthorizedMessage from '../UnauthorizedMessage';

export default observer(function EditProfile() {
  const {
    profileStore: {
      profile,
      uploadPhoto,
      deletePhoto,
      uploading,
      loading,
      setMainPhoto,
      loadProfile,
    },
    dashboardStore,
    userStore,
    commonStore,
  } = useStore();

  useEffect(() => {
    if (userStore?.user?.id !== undefined) {
      loadProfile(userStore?.user?.id);
    }
  }, [loadProfile, userStore]);

  const [addPhotoMode, setAddPhotoMode] = useState(false);
  const [target, setTarget] = useState('');

  function handlePhotoUpload(file: Blob) {
    uploadPhoto(file).then(() => setAddPhotoMode(false));
  }

  function handleSetMainPhoto(
    photo: Photo,
    e: SyntheticEvent<HTMLButtonElement>,
  ) {
    setTarget(e.currentTarget.name);
    setMainPhoto(photo);
  }

  function handleDeletePhoto(
    photo: Photo,
    e: SyntheticEvent<HTMLButtonElement>,
  ) {
    setTarget(e.currentTarget.name);
    deletePhoto(photo);
  }

  return (
    <>
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('MPB01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('MPB01') && (
        <Tab.Pane>
          <div className="profile-edit">
            <Grid>
              <Grid.Column width={16}>
                <Header
                  floated="left"
                  icon="image"
                  content={
                    (userLanguage[0].UploadProfilePhoto?.UPPPH01 as any)?.[
                      `${commonStore.language.key}`
                    ]
                  } //"Photos"
                />

                {commonStore.filterModeTwo?.includes('UPPB01') ? (
                  <></>
                ) : (
                  <Button
                    floated="right"
                    primary
                    //"Cancel"://"Add Photo"
                    content={
                      addPhotoMode
                        ? (userLanguage[0].UploadProfilePhoto?.UPPB04 as any)?.[
                            `${commonStore.language.key}`
                          ]
                        : (userLanguage[0].UploadProfilePhoto?.UPPB01 as any)?.[
                            `${commonStore.language.key}`
                          ]
                    }
                    onClick={() => setAddPhotoMode(!addPhotoMode)}
                    disabled={commonStore.filterModeZero?.includes('UPPB01')}
                  />
                )}
              </Grid.Column>
              <Grid.Column width={16}>
                {addPhotoMode ? (
                  <PhotoUploadWidget
                    uploadPhoto={handlePhotoUpload}
                    loading={uploading}
                  />
                ) : (
                  <Card.Group itemsPerRow={5}>
                    {profile &&
                      profile.photos?.map((photo) => (
                        <Card key={photo.id}>
                          <ImageTag imageUrl={photo.url} />
                          <Button.Group fluid widths={2}>
                            {commonStore.filterModeTwo?.includes('UPPB02') ? (
                              <></>
                            ) : (
                              <Button
                                basic
                                color="green"
                                content={
                                  (
                                    userLanguage[0].UploadProfilePhoto
                                      ?.UPPB02 as any
                                  )?.[`${commonStore.language.key}`]
                                } //"Make Profile Picture"
                                name={'main' + photo.id}
                                disabled={
                                  photo.isMain ||
                                  commonStore.filterModeZero?.includes('UPPB02')
                                }
                                loading={
                                  target === 'main' + photo.id && loading
                                }
                                onClick={(e) => handleSetMainPhoto(photo, e)}
                              />
                            )}
                            {commonStore.filterModeTwo?.includes('UPPB03') ? (
                              <></>
                            ) : (
                              <Button
                                basic
                                color="red"
                                content={
                                  (
                                    userLanguage[0].UploadProfilePhoto
                                      ?.UPPB03 as any
                                  )?.[`${commonStore.language.key}`]
                                } //"Delete"
                                loading={target === photo.id && loading}
                                onClick={(e) => handleDeletePhoto(photo, e)}
                                disabled={
                                  photo.isMain ||
                                  commonStore.filterModeZero?.includes('UPPB03')
                                }
                                name={photo.id}
                              />
                            )}
                          </Button.Group>
                        </Card>
                      ))}
                  </Card.Group>
                )}
              </Grid.Column>
            </Grid>
          </div>
        </Tab.Pane>
      )}
    </>
  );
});
